module.exports = __webpack_public_path__ + "img/CV.9975bad1.svg";